import {requestMs} from "@helpers/api";

export const appointments = {
  getAll: ({ userId, search, filter, page,  dateFrom, dateTo }) => requestMs.get(`api3/user/${userId}/appointment?page=${page}${filter}${search}${dateFrom}${dateTo}`),
  create: params => requestMs.post(`/api3/appointment/${ params.userId }`, params),
  cancel: params => requestMs.delete(`/api3/appointment/${ params.userId }/${ params.appointmentId }/${ params.reasonId }`, {})
};
